export default "__VITE_ASSET__2ef51791__"